export default __webpack_public_path__ + "static/media/billreynolds_tennis_court.473d9779.jpg";